var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"mb-5"},[_c('div',{staticClass:"my-4"},[_c('h1',[_vm._v("Convocations")])]),_c('hr')])])}
var staticRenderFns = []

export { render, staticRenderFns }